import React from 'react';
import DateTimePicker from 'react-datetime-picker'
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import './date-time-picker.css'



const DateAndTimePicker = ({onChange, value, setDateError}) => {

  return (
    <div className='h-[56px] w-full sm:w-[350px] bg-white text-black rounded-lg'>
      <DateTimePicker
      className=""
      value={value}
      onChange={(newValue) => {
        setDateError("")
        onChange(newValue)
      }}
      minDate={new Date()}
      required={true}
      clearIcon={null}
      calendarIcon={null}
      format='y/MM/dd HH:mm'
      onInvalidChange={() => {
        setDateError("Invalid date and time")
      }}
       />
    </div>
  )

};

export default DateAndTimePicker;
